// library modules
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  List,
  Datagrid,
  SearchInput,
  Filter,
  TextField,
  DateField,
  ResourceContextProvider,
  useRecordContext,
  EditButton,
  useTranslate,
} from 'react-admin';
import { CustomerContext } from '../../../context/customerContext';

// components
import { Box } from '@mui/material';
import CustomButton from '../../shared/CustomButton';
import AddIcon from '@mui/icons-material/Add';
import ActionDropdown from '../../shared/ActionDropdown';
import BatchDeleteButton from '../../shared/BatchDeleteButton';
import UrlField from '../../shared/UrlField';
import DeleteConfirmationDialog from '../../shared/DeleteConfirmationDialog';
import { InitialDataContext } from '../../../context/initialDataContext';

const RESOURCE = 'customer-document-contract';
const CREATE_PAGE = '/add-contracts';

const DropdownMenu = () => {
  const translate = useTranslate();
  const record = useRecordContext();

  const options = [
    <EditButton record={record} resource='edit-contract' key={'edit'} />,
    <DeleteConfirmationDialog
      message={translate('notifications.document_deleted')}
      title={`${translate('resources.contracts.delete_contract')} ${
        record.name
      }?`}
      key={`${record.id} + delete`}
    />,
  ];

  return <ActionDropdown options={options} />;
};

const ContractsFilter = (props) => {
  const navigate = useNavigate();
  const translate = useTranslate();

  const handleClick = () => {
    navigate(CREATE_PAGE);
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: '3rem',
      }}
    >
      <Filter {...props} variant='outlined'>
        <SearchInput
          source='customerContractsSearch'
          variant='outlined'
          alwaysOn
          resettable={true}
        />
      </Filter>
      <CustomButton
        variant='secondary'
        title={translate('resources.contracts.add_contract')}
        handleClick={handleClick}
        startIcon={<AddIcon />}
      />
    </Box>
  );
};

const ContractsList = () => {
  const translate = useTranslate();
  const { customer } = useContext(CustomerContext);
  const initialData = useContext(InitialDataContext);

  return (
    <>
      <ResourceContextProvider resource={RESOURCE}>
        <List
          actions={null}
          filters={<ContractsFilter />}
          resource={RESOURCE}
          filter={{
            documentTypeId: initialData?.contractId,
            customerId: customer ? customer?.id.toString() : '0',
          }}
          empty={false}
        >
          <Datagrid
            bulkActionButtons={<BatchDeleteButton resource='media-item' />}
          >
            <TextField source='name' />
            <DateField
              source='signatureDate'
              locales='de-DE'
              label={translate('common.singnature_date')}
            />
            <DateField
              source='endDate'
              locales='de-DE'
              label={translate('common.end_date')}
            />
            <UrlField source='url' label={translate('common.table.url')} />
            <DropdownMenu
              label={translate('common.table.actions')}
              textAlign='center'
            />
          </Datagrid>
        </List>
      </ResourceContextProvider>
    </>
  );
};

export default ContractsList;
